import React from "react";
import { Paper, IconButton, Divider, Tooltip } from "@mui/material";
import TextFieldsIcon from "@mui/icons-material/TextFields";
import RectangleOutlinedIcon from "@mui/icons-material/RectangleOutlined";
import PanoramaFishEyeIcon from "@mui/icons-material/PanoramaFishEye";
import ImageIcon from "@mui/icons-material/Image";
import DeleteIcon from "@mui/icons-material/Delete";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import UndoIcon from "@mui/icons-material/Undo";
import RedoIcon from "@mui/icons-material/Redo";

export default function EditorToolbar({
    onAddText,
    onAddRect,
    onAddCircle,
    onAddImage,
    onDelete,
    onDuplicate,
    onMoveUp,
    onMoveDown,
    hasSelection,
    onFileChange,
    onUndo,
    onRedo,
    canUndo,
    canRedo,
}) {
    return (
        <Paper
            elevation={3}
            square
            sx={{ width: 60, display: "flex", flexDirection: "column", alignItems: "center", py: 2, gap: 0.5, flexShrink: 0 }}
        >
            <Tooltip title="Annuler (Ctrl+Z)" placement="right">
                <span>
                    <IconButton onClick={onUndo} disabled={!canUndo}>
                        <UndoIcon />
                    </IconButton>
                </span>
            </Tooltip>
            <Tooltip title="Rétablir (Ctrl+Y)" placement="right">
                <span>
                    <IconButton onClick={onRedo} disabled={!canRedo}>
                        <RedoIcon />
                    </IconButton>
                </span>
            </Tooltip>

            <Divider flexItem sx={{ my: 0.5 }} />
            <Tooltip title="Texte" placement="right">
                <IconButton onClick={onAddText}><TextFieldsIcon /></IconButton>
            </Tooltip>
            <Tooltip title="Rectangle" placement="right">
                <IconButton onClick={onAddRect}><RectangleOutlinedIcon /></IconButton>
            </Tooltip>
            <Tooltip title="Cercle / Ellipse" placement="right">
                <IconButton onClick={onAddCircle}><PanoramaFishEyeIcon /></IconButton>
            </Tooltip>
            <Tooltip title="Image" placement="right">
                <IconButton onClick={onAddImage}><ImageIcon /></IconButton>
            </Tooltip>

            <Divider flexItem sx={{ my: 0.5 }} />

            <Tooltip title="Dupliquer (Ctrl+D)" placement="right">
                <span>
                    <IconButton onClick={onDuplicate} disabled={!hasSelection}>
                        <ContentCopyIcon />
                    </IconButton>
                </span>
            </Tooltip>
            <Tooltip title="Supprimer (Suppr)" placement="right">
                <span>
                    <IconButton onClick={onDelete} disabled={!hasSelection} color="error">
                        <DeleteIcon />
                    </IconButton>
                </span>
            </Tooltip>

            <Divider flexItem sx={{ my: 0.5 }} />

            <Tooltip title="Avancer d'un calque" placement="right">
                <span>
                    <IconButton onClick={onMoveUp} disabled={!hasSelection}>
                        <KeyboardArrowUpIcon />
                    </IconButton>
                </span>
            </Tooltip>
            <Tooltip title="Reculer d'un calque" placement="right">
                <span>
                    <IconButton onClick={onMoveDown} disabled={!hasSelection}>
                        <KeyboardArrowDownIcon />
                    </IconButton>
                </span>
            </Tooltip>
        </Paper>
    );
}
